//@flow
export const GET_WORKERS_DATA='GET_WORKERS_DATA';
export const GET_WORKERS_DATA_ERROR='GET_WORKERS_DATA_ERROR';
export const OPEN_ADD_OR_EDIT_FORM='OPEN_ADD_OR_EDIT_FORM';
export const CANCEL_ADD_OR_EDIT_FORM='CANCEL_ADD_OR_EDIT_FORM';
export const NEW_WORKER_CREATED='NEW_WORKER_CREATED';
export const NEW_WORKER_CREATE_ERROR='NEW_WORKER_CREATED_ERROR';
export const SELECTED_A_WORKER='SELECTED_A_WORKER';
export const WORKER_UDPATED='WORKER_UDPATED';
export const WORKER_UDPATE_ERROR='WORKER_UDPATE_ERROR';
export const WORKER_CRUD_WAIT='WORKER_CRUD_WAIT'


// WEBPACK FOOTER //
// ./src/redux/worker/actionTypes.js